import React, { useEffect, useState } from "react";
import { Box, Grid } from "@mui/material";
import CardOffert from "./CardOffert";
import { handleError } from "../../../../utils/handleError";
import toast from "react-hot-toast";
import { getAllPromotionsAPI } from "../../../../services/rest/Promotions/promotionsService";
import Loading from "../../../../components/Loading/Loading";
import { useSelector } from "react-redux";

const OffertsOfUser = () => {
  const [promotionsUnlocked, setPromotionsUnlocked] = useState([]);
  const [loading, setLoading] = useState(true);
  const { membershipStatus } = useSelector((state) => state.membershipReducer);

  useEffect(() => {
    if (membershipStatus !== "active") {
      setLoading(false);
      toast.error(
        "Su membresía no esta activa. \n Adquiere una membresía para ver esta sección."
      );
      return;
    }
    const getAllPromotions = async () => {
      try {
        setLoading(true);
        const responsePromotions = await getAllPromotionsAPI();
        const promotionsActive =
          responsePromotions.filter(
            (promotion) => promotion?.status === "active"
          ) ?? [];
        setPromotionsUnlocked(promotionsActive ?? []);
        setLoading(false);
      } catch (error) {
        const { message } = handleError(error);
        setLoading(false);
        toast.error(`No se pudieron obtener las promociones. \n ${message}`);
      }
    };
    getAllPromotions();
  }, []);

  return (
    <Box
      sx={{
        paddingLeft: 4,
        paddingRight: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 4,
      }}
    >
      <Loading loading={loading} />
      <Box
        sx={{
          display: "flex",
          flexWrap: "wrap",
          gap: 5,
          // justifyContent: { xs: "center", sm: "flex-center" },
          alignItems: "stretch", // Esto iguala las alturas
        }}
      >
        {promotionsUnlocked.length === 0 && !loading && (
          <Box
            sx={{
              width: "100%",
              textAlign: "center",
              padding: 2,
              color: "text.secondary",
            }}
          >
            No hay promociones disponibles.
          </Box>
        )}
        {promotionsUnlocked &&
          promotionsUnlocked.map((offert) => (
            <Box
              key={offert?._id}
              sx={{
                display: "flex", // Esto ayuda a que el contenido interno también estire
              }}
            >
              <CardOffert offert={offert} />
            </Box>
          ))}
      </Box>
    </Box>
  );
};

export default OffertsOfUser;
